<template>
    <b-row>
        <div class="d-flex mt-3">
            <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
            <h6 class="bold-heading mt6 ms-1">{{ $t('Configuration.title') }}</h6>
        </div>
    </b-row>
    <!-- {{ dataObj.BatchRequired[0] == 'true' }} -->

    <b-row class="my-2 ps-3">
        <b-col>

            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.ExpiryDtRequired[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('Configuration.Requiredexpirydate') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.BatchRequired[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('Configuration.Requiredbatchno') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.IsNonChargable[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('Configuration.Isnonchargeable') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.IsConsignee[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('Configuration.Isconsignee') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.NoMrp[0] == 'true'" class='greentick me-3' src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('Configuration.AutoConsumed') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.AutoConsumed[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('Configuration.Asset') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.HighValueFlag[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('Configuration.HighValue') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.IsxrayFilm[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('Configuration.XRayFilms') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-field-column d-flex">
                    <img v-if="dataObj.IsGSTExempt[0] == 'true'" class='greentick me-3'
                        src="../../../../assets/Img/icons/tick-01.svg">

                    <img v-else class='greentick me-3' src="../../../../assets/Img/icons/close-01.svg">
                    <p class="descryption-grey-text">{{ $t('Configuration.IsGSTExempt') }}</p>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {

        }
    }

})
</script>

<style lang="scss"></style>